module.exports = {
	"v": "4.8.0",
	"fr": 30,
	"ip": 0,
	"op": 21,
	"w": 150,
	"h": 150,
	"nm": "render",
	"ddd": 0,
	"assets": [
		{
			"id": "comp_0",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 0,
					"nm": "burger_to_empty",
					"refId": "comp_1",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								75,
								75,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								75,
								75,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"w": 150,
					"h": 150,
					"ip": 0,
					"op": 101,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 0,
					"nm": "empty_to_cross",
					"refId": "comp_2",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								75,
								75,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								75,
								75,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"w": 150,
					"h": 150,
					"ip": 0,
					"op": 101,
					"st": 0,
					"bm": 0,
					"sr": 1
				}
			]
		},
		{
			"id": "comp_1",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "Shape Layer 3",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								16.812,
								32,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								-58.188,
								0,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833,
											0.833,
											0.833
										],
										"y": [
											1,
											1,
											1
										]
									},
									"o": {
										"x": [
											0.333,
											0.333,
											0.333
										],
										"y": [
											0,
											0,
											0
										]
									},
									"n": [
										"0p833_1_0p333_0",
										"0p833_1_0p333_0",
										"0p833_1_0p333_0"
									],
									"t": 0,
									"s": [
										100,
										100,
										100
									],
									"e": [
										0,
										100,
										100
									]
								},
								{
									"t": 10
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"d": 1,
									"s": {
										"a": 0,
										"k": [
											116.67,
											6.045
										]
									},
									"p": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"r": {
										"a": 0,
										"k": 0
									},
									"nm": "Rectangle Path 1",
									"mn": "ADBE Vector Shape - Rect"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0,
											0,
											0,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0.335,
											0.023
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Rectangle 2",
							"np": 3,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 101,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 4,
					"nm": "Shape Layer 1",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": 0.833,
										"y": 1
									},
									"o": {
										"x": 0.167,
										"y": 0
									},
									"n": "0p833_1_0p167_0",
									"t": 7,
									"s": [
										16.812,
										74.75,
										0
									],
									"e": [
										71.812,
										74.75,
										0
									],
									"to": [
										9.16666698455811,
										0,
										0
									],
									"ti": [
										-9.16666698455811,
										0,
										0
									]
								},
								{
									"t": 17
								}
							]
						},
						"a": {
							"a": 0,
							"k": [
								-58.188,
								0,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833,
											0.833,
											0.833
										],
										"y": [
											1,
											1,
											1
										]
									},
									"o": {
										"x": [
											0.333,
											0.333,
											0.333
										],
										"y": [
											0,
											0,
											0
										]
									},
									"n": [
										"0p833_1_0p333_0",
										"0p833_1_0p333_0",
										"0p833_1_0p333_0"
									],
									"t": 7,
									"s": [
										100,
										100,
										100
									],
									"e": [
										0,
										100,
										100
									]
								},
								{
									"t": 17
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"d": 1,
									"s": {
										"a": 0,
										"k": [
											116.67,
											6.045
										]
									},
									"p": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"r": {
										"a": 0,
										"k": 0
									},
									"nm": "Rectangle Path 1",
									"mn": "ADBE Vector Shape - Rect"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0,
											0,
											0,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0.335,
											0.023
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Rectangle 2",
							"np": 3,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 101,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 4,
					"nm": "Shape Layer 2",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								16.812,
								117.5,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								-58.188,
								0,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833,
											0.833,
											0.833
										],
										"y": [
											1,
											1,
											1
										]
									},
									"o": {
										"x": [
											0.333,
											0.333,
											0.333
										],
										"y": [
											0,
											0,
											0
										]
									},
									"n": [
										"0p833_1_0p333_0",
										"0p833_1_0p333_0",
										"0p833_1_0p333_0"
									],
									"t": 4,
									"s": [
										100,
										100,
										100
									],
									"e": [
										0,
										100,
										100
									]
								},
								{
									"t": 14
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"d": 1,
									"s": {
										"a": 0,
										"k": [
											116.67,
											6.045
										]
									},
									"p": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"r": {
										"a": 0,
										"k": 0
									},
									"nm": "Rectangle Path 1",
									"mn": "ADBE Vector Shape - Rect"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0,
											0,
											0,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0.335,
											0.023
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Rectangle 2",
							"np": 3,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 101,
					"st": 0,
					"bm": 0,
					"sr": 1
				}
			]
		},
		{
			"id": "comp_2",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "Shape Layer 3",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0p833_1_0p333_0"
									],
									"t": 8,
									"s": [
										0
									],
									"e": [
										45
									]
								},
								{
									"t": 20
								}
							]
						},
						"p": {
							"a": 0,
							"k": [
								75.438,
								74.977,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								0.438,
								0,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833,
											0.833,
											0.833
										],
										"y": [
											1,
											1,
											1
										]
									},
									"o": {
										"x": [
											0.167,
											0.167,
											0.167
										],
										"y": [
											0,
											0,
											0
										]
									},
									"n": [
										"0p833_1_0p167_0",
										"0p833_1_0p167_0",
										"0p833_1_0p167_0"
									],
									"t": 0,
									"s": [
										0,
										100,
										100
									],
									"e": [
										100,
										100,
										100
									]
								},
								{
									"t": 10
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"d": 1,
									"s": {
										"a": 0,
										"k": [
											116.67,
											6.045
										]
									},
									"p": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"r": {
										"a": 0,
										"k": 0
									},
									"nm": "Rectangle Path 1",
									"mn": "ADBE Vector Shape - Rect"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0,
											0,
											0,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0.335,
											0.023
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Rectangle 2",
							"np": 3,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 101,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 4,
					"nm": "Shape Layer 1",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0p833_1_0p333_0"
									],
									"t": 8,
									"s": [
										0
									],
									"e": [
										-45
									]
								},
								{
									"t": 20
								}
							]
						},
						"p": {
							"a": 0,
							"k": [
								75.312,
								74.977,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								0.312,
								0,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833,
											0.833,
											0.833
										],
										"y": [
											1,
											1,
											1
										]
									},
									"o": {
										"x": [
											0.167,
											0.167,
											0.167
										],
										"y": [
											0,
											0,
											0
										]
									},
									"n": [
										"0p833_1_0p167_0",
										"0p833_1_0p167_0",
										"0p833_1_0p167_0"
									],
									"t": 4,
									"s": [
										0,
										100,
										100
									],
									"e": [
										100,
										100,
										100
									]
								},
								{
									"t": 14
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ty": "rc",
									"d": 1,
									"s": {
										"a": 0,
										"k": [
											116.67,
											6.045
										]
									},
									"p": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"r": {
										"a": 0,
										"k": 0
									},
									"nm": "Rectangle Path 1",
									"mn": "ADBE Vector Shape - Rect"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0,
											0,
											0,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0.335,
											0.023
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Rectangle 2",
							"np": 3,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 101,
					"st": 0,
					"bm": 0,
					"sr": 1
				}
			]
		}
	],
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 0,
			"nm": "burger_to_cross",
			"refId": "comp_0",
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						75,
						75,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						75,
						75,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					]
				}
			},
			"ao": 0,
			"w": 150,
			"h": 150,
			"ip": 0,
			"op": 21,
			"st": 0,
			"bm": 0,
			"sr": 1
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/json/burger-to-cross.json
// module id = 500
// module chunks = 0